import { useState, useEffect } from "react";
import { useLogin } from "../hooks/useLogin";
import { useLocation } from "react-router-dom";
import { useLanguageContext } from "../hooks/useLanguageContext";
import translations from "../translations";
import "./Login.css";

const Login = () => {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const { login, error, isLoading } = useLogin();
  const [refQuery, setRefQuery] = useState("");
  const { language, setLanguage } = useLanguageContext();

  const t = translations[language] || translations.nl;

  const location = useLocation();

  useEffect(() => {
    const searchParams = new URLSearchParams(location.search);
    const refParam = searchParams.get("ref");
    if (refParam) {
      console.log("Ref parameter detected:", refParam);
      setRefQuery(refParam);
    }
  }, [location.search]);

  const handleSubmit = async (e) => {
    e.preventDefault();
    await login(email.toLowerCase(), password);
  };

  return (
    <div className="login-container">
      <div className="login-box">
        <div style={{ display: "flex", justifyContent: "flex-end", marginBottom: "16px" }}>
          <select
            className="language-select"
            value={language}
            onChange={(e) => setLanguage(e.target.value)}
          >
            <option value="nl">Nederlands</option>
            <option value="en">English</option>
            <option value="de">Deutsch</option>
            <option value="fr">Français</option>
          </select>
        </div>

        <div className="logo-container">
          {refQuery === "wpk" ? (
            <img
              src="/wpk-logo.svg"
              alt="WPK Logo"
              className="logo"
            />
          ) : refQuery === "pvangeest" ? (
            <img
              src="/p-van-geest-plantenkwekerij-logo_100px.png"
              alt="P. van Geest Logo"
              className="logo"
            />
          ) : null}
        </div>

        <h2 className="login-title">{t.login.title}</h2>

        <form className="login-form" onSubmit={handleSubmit}>
          <label htmlFor="email">{t.login.email}</label>
          <input
            id="email"
            type="email"
            className="input-field"
            placeholder="info@bedrijf.com"
            onChange={(e) => setEmail(e.target.value)}
            value={email}
          />

          <label htmlFor="password">{t.login.password}</label>
          <input
            id="password"
            type="password"
            className="input-field"
            placeholder="Welkom123"
            onChange={(e) => setPassword(e.target.value)}
            value={password}
          />
          {refQuery === "wpk" ? (
          <button className="login-button" disabled={isLoading}>
            {t.login.button}
          </button>
          ) : refQuery === "pvangeest" ? (
            <button className="login-button" disabled>
            Tijdelijk niet beschikbaar wegens onderhoud.<br/><br/>
            Down for maintenance.
          </button>
          ) : null}
        </form>

        {error && <div className="error-message">{error}</div>}

        <a
          href={`/forgot-password?ref=${refQuery}`}
          className="forgot-password"
        >
          {t.login.forgotPassword}
        </a>
      </div>
    </div>
  );
};

export default Login;